import React from "react";
import {
  seriesContacts,
  categories,
  seriesAccounts,
  seriesAccountsPie,
} from "./data";
import { ChartsSetWrapper } from "../../../../../components";

const DonutList = () => {
  return (
    <div className="flex-1 flex overflow-auto">
      <div className="flex-1  grid grid-cols-3 auto-rows-[400px] gap-4">
        <ChartsSetWrapper
          title="Donut Chart"
          type={"donut"}
          series={seriesContacts}
          categories={categories}
          loading={false}
          options={{
            legend: { show: false },
            showLabels: {
              show: true,
              valueDisplay: "percentage",
              color: "white",
            },
          }}
        />
        <ChartsSetWrapper
          title="Donut Chart"
          type={"donut"}
          series={seriesContacts}
          categories={categories}
          loading={false}
          options={{
            legend: { show: false },
            pie: { gap: 1, circle: "half" },
          }}
        />
      </div>
    </div>
  );
};

export default DonutList;
